<template>
  <div>
    <section class="time-off-report-page container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-table-header full-height-page-wrapper">
            <PageHeader showBreadcrumbs page-title="Time off report - overview">
              <template #buttons>
                <DatePeriodNavigation :start-date="selectedYearDate" :disable-prev="isFirstYearSelected"
                  :disable-next="isLastYearSelected" :single-mode="true" minimum-view="year" date-format="yyyy"
                  @changePeriod="handleYearChange" @selectDate="handleYearSelect" />
                <multiselect v-if="isPage || !timeOffReportUserId" v-model="employmentType" :options="employmentSelect"
                  :placeholder="'All employment types'" :track-by="'value'" :label="'label'" :allow-empty="false"
                  :showLabels="false" style="min-width: 200px" />
                <div class="d-flex align-items-center">
                  <CloseButton v-if="!isPage" :onClick="onClose" />
                </div>
              </template>
            </PageHeader>
            <div v-if="isLoading" class="content-loading-wrapper" style="min-height: 60vh">
              <Preloader class="centered-preloader large-spinner" customClasses="time-log-loader" />
            </div>
            <div class="table-responsive-outter-wrapper">
              <div class="table-responsive-wrapper" :style="{
                width: shouldUseFullWidth ? '100%' : 'min-content'
              }" v-if="
                  !isLoading &&
                  reportsData.length &&
                  selectedYearData &&
                  tableData.length && !!timeOffsSettings
                ">
                <TableForPage :fields="tableColumns" :tableData="tableData" :slots="reportSlots"
                  class="time-off-user-table" @update="updateTable" :stickyHeader="false" :colGroups="colGroups">
                  <template v-slot:index="slotProps">
                    <IndexColumn :index="slotProps.index" :currentPage="currentPage" :itemsPerPage="perPage"
                      :isLoading="isLoading" />
                  </template>
                  <template v-slot:name="slotProps">
                    <TableUserItem :user="slotProps.item.user" :number="getNumber(slotProps.index)" />
                  </template>

                  <template v-slot:head(worked_days)="slotProps">
                    <div style="
                  display: flex;
                  align-items: center;
                  gap: 2px;
                ">
                      Workdays passed
                      <span class="material-symbols-outlined" style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      cursor: help;
                    " v-b-tooltip.hover="{ variant: 'base', placement: 'top', boundary: 'viewport', delay: { show: 300, hide: 0 } }"
                        title="Includes regular workdays and time offs that allow continuing to accrue other leave.">
                        info
                      </span>
                    </div>
                  </template>

                  <template v-slot:[`head(${item.key})`]="slotProps" v-for="item in colGroups">
                    <div class="d-flex align-items-center justify-content-center" style="
                    text-transform: none !important;
                  " :style="{
                    minWidth: item.colspan === 1 ? '121px' : '170px'
                  }" :key="item.key">
                      <div class="d-flex align-items-center justify-content-center">
                        <TimeOffIcon v-if="item.icon" :name="item.icon.icon"
                          :style="{ color: item.icon.color, minWidth: 'fit-content' }" />
                        <span class="pl-2">{{ item.key.toUpperCase() }}</span>
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`${item}`]="slotProps" v-for="item in Object.keys(dynamicUserSlots)">
                    <div :key="item">
                      <span>{{ `${slotProps.item[`${item}`]}` }}</span>
                      <span v-if="slotProps.item[`${item}adjust`]" :style="`color: ${slotProps.item[`${item}adjust`] < 0 ? '#DC3545' : '#3FA52F'
                        }`">
                        ({{
                          slotProps.item[`${item}adjust`] >= 0
                            ? "+" + slotProps.item[`${item}adjust`]
                            : "" + slotProps.item[`${item}adjust`]
                        }})
                      </span>
                    </div>
                  </template>

                  <template v-slot:action="slotProps">
                    <div class="actions-wrap">
                      <span :id="`${slotProps.item.user.id}-action`" class="material-symbols-outlined icon-color"
                        @click="() => visibilityActionClick(slotProps)">
                        visibility
                      </span>
                      <span @click="() => handleEditClick(slotProps.item.user.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                          <path
                            d="M12.2167 7.51667L12.9833 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.51667ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5.01667 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z"
                            fill="#3D5170" />
                        </svg>
                      </span>
                    </div>
                  </template>

                  <template v-slot:row="slotProps">
                    <div v-if="
                      userDetailsDataLoading &&
                      userDetailsDataLoading == slotProps.row.item.user.id
                    " class="p-2 d-flex justify-content-center">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <TimeOffReportDetailsRow v-if="detailsData[slotProps.row.item.user.id]" :rowData="slotProps.row"
                      :detailsData="detailsData[slotProps.row.item.user.id]" :selectedYear="selectedYear"
                      :showModalOnInit="showModalOnInit" :slotProps="slotProps" :userId="slotProps.row.item.user.id"
                      @dataUpdated="dataUpdated" @showAdjustModal="handleEditClick" />
                  </template>
                </TableForPage>
              </div>
            </div>
            <div v-if="
              !isLoading &&
              reportsData.length &&
              !tableData.length
            " class="full-height-content">
              <EmptyStateNoResults @reset-filters="handleResetFilters" />
            </div>
            <div v-if="!isLoading && !reportsData.length" class="full-height-content">
              <EmptyStateNoResults iconClasses="material-symbols-outlined" customIcon="schedule" title="No time off yet"
                description="You haven’t recorded any time off. When you do, it’ll appear here." withoutButton />
            </div>
            <div class="used-by-months-table-wrapper" :style="{
              width: shouldUseFullWidthForMonths ? '100%' : 'min-content'
            }" v-if="!isPage && !hideMonthsSection && selectedYearMonthsData">
              <div class="table-responsive-wrapper">
                <TableForPage v-if="selectedYearMonthsData" title="Used by months" :fields="monthsTableColumns"
                  :slots="monthsSlots" :tableData="monthsTableData" :stickyHeader="false"
                  tableClass="table-layout-fixed used-by-months-table">
                  <template v-slot:month="slotProps">
                    <div class="d-flex align-items-center gap-5"
                      :class="slotProps.item.items.length && 'cursor-pointer'" @click="
                        slotProps.item.items.length && slotProps.toggleDetails()
                        ">
                      <span :class="`material-symbols-outlined material-symbols-fill-1 user-select-none ${!slotProps.item.items.length && 'color-text-none'
                        }`" :style="{
                        transform: slotProps.detailsShowing
                          ? 'rotate(180deg)'
                          : 'none',
                        transition: '0.2s',
                      }">
                        keyboard_arrow_down
                      </span>
                      <span>
                        {{ slotProps.item.month }}
                      </span>
                    </div>
                  </template>

                  <template v-slot:[`head(${item.key})`]="slotProps" v-for="item in monthsDynamicTableColumns">
                    <div class="align-items-center justify-content-center" style="
                      text-transform: none !important;
                      display: flex;
                      gap: 12px;
                    " :style="{
                      minWidth: getColumnMinWidth(item.label.text)
                    }" :key="item.key">
                      <div class="d-flex align-items-center justify-content-center">
                        <TimeOffIcon :name="item.label.icon.icon"
                          :style="{ color: item.label.icon.color, minWidth: 'fit-content' }" />
                        <span class="pl-2">{{ item.label.text }}</span>
                      </div>
                      <span style="white-space: nowrap;">{{ item.label.value }}</span>
                    </div>
                  </template>

                  <template v-slot:[`${item}`]="slotProps" v-for="item in Object.keys(monthsDynamicSlots)">
                    <span :key="item" v-if="slotProps.item.summ && item === slotProps.item.type">
                      {{ slotProps.item.summ + " d" }}
                    </span>
                    <NoDataText v-else :key="item + 'none'" />
                  </template>

                  <template v-slot:row="slotProps">
                    <table class="table b-table months-subtable" style="
                      width: calc(100% + 20px);
                      margin: -10px;
                      background-color: #f3f5f7;
                    ">
                      <thead style="visibility: hidden; height: 0; opacity: 0; line-height: 0;">
                        <tr>
                          <th class="">Months</th>
                          <th class="item-width text-center nested-table-left-border nested-table-right-border"
                            v-for="(e, i) in monthsDynamicTableColumns" :key="i + 'header'" :style="{
                              minWidth: getColumnMinWidth(e.label.text, 21),
                              width: getColumnMinWidth(e.label.text, 21) + ' !important'
                            }">
                            <div class="align-items-center"
                              style="text-transform: none !important; display: flex; gap: 12px;">
                              <div class="d-flex align-items-center justify-content-center">
                                <TimeOffIcon :name="e.label.icon.icon"
                                  :style="{ color: e.label.icon.color, minWidth: 'fit-content' }" />
                                <span class="pl-2">{{ e.label.text }}</span>
                              </div>
                              <span>{{ e.label.value }}</span>
                            </div>
                          </th>
                          <th class="column-controls-md"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in slotProps.row.item.items" :key="index + 'item'"
                          class="detailed-dates-row">
                          <td class="">
                            <span style="padding: 0 25px">
                              {{ item.date }}
                            </span>
                          </td>
                          <td class="item-width text-center nested-table-left-border nested-table-right-border"
                            v-for="(e, i) in monthsDynamicTableColumns" :key="i + 'el'" :style="{
                              minWidth: getColumnMinWidth(e.label.text, 21),
                              width: getColumnMinWidth(e.label.text, 21) + ' !important'
                            }">
                            <div class="text-center" v-if="e.key === item.type">
                              {{ item.days }} d
                            </div>
                            <span v-else class="color-text-none" style="visibility: hidden;">none</span>
                          </td>
                          <td class="column-controls-md"></td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </TableForPage>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Adjust Modal -->
    <b-modal size="lg" hide-footer v-model="isShowAdjustModal" centered
      :modal-class="{ 'loading': isSubmittingAdjustment }">
      <template v-slot:modal-header="{ cancel }">
        <ModalHeader title="Add adjustments" :onCloseButton="cancel" closeButtonId="adjustModal" />
      </template>
      <FormGenerator ref="form" :data="adjustModalFields" textButtonSubmit="Save" textButtonReset="Cancel"
        @submit="submitAdjustment" @updateItem="updateAdjustModalItem" @reset="closeAdjustModal">
        <template v-slot:allowed="slotProps">
          <b-form-group>
            <label class="form__label">{{ slotProps.data.label }}</label>
            <b-form-input type="text" :placeholder="slotProps.data.placeholder" v-model="slotProps.data.value"
              readonly />
            <slot name="errors"></slot>
          </b-form-group>
        </template>
        <template v-slot:description="slotProps">
          <b-form-group>
            <label class="form__label">{{ slotProps.data.label }}</label>
            <b-form-textarea id="textarea" :value="adjustModalFields.description.value"
              @input="(value) => { updateDescriptionValue(value); slotProps.data.value = value }"
              :placeholder="slotProps.data.placeholder" rows="2" max-rows="6" />
          </b-form-group>
        </template>
      </FormGenerator>
      <div class="d-flex align-items-center text-left" style="margin-top: -25px;">
        <span class="material-symbols-outlined icon-color mr-2">visibility</span>
        <template v-if="isPayable">
          This is payable time off
        </template>
        <template v-else>
          This is not payable time off
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'
import IndexColumn from '@components/tables/elements/Index'
import TableUserItem from '@components/tables/TableUserItem'
import TimeOffReportDetailsRow from '@components/tables/elements/TimeOffReportDetailsRow'
import CloseButton from '@components/common/CloseButton.vue'
import PageHeader from '@components/PageHeader.vue'
import NoDataText from '@components/common/NoDataText'
import Preloader from '@components/Preloader'
import { mapGetters } from 'vuex'
import TimeOffIcon from '@components/TimeOffIcon.vue'
import EmptyStateNoResults from '@components/EmptyStateNoResults'
import FormGenerator from '@components/FormGenerator'
import ModalHeader from '@components/modals/ModalHeader.vue'
import DatePeriodNavigation from '@components/DatePeriodNavigation.vue'
import moment from 'moment'

export default {
  name: 'TimeOffReportOverview',
  components: {
    TableForPage,
    IndexColumn,
    TableUserItem,
    TimeOffReportDetailsRow,
    CloseButton,
    PageHeader,
    NoDataText,
    Preloader,
    TimeOffIcon,
    EmptyStateNoResults,
    FormGenerator,
    ModalHeader,
    DatePeriodNavigation
  },
  props: {
    isPage: {
      type: Boolean,
      default: true
    },
    timeOffReportUserId: {
      type: Number,
      default: null
    },
    hideMonthsSection: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  data () {
    return {
      isLoading: true,
      userDetailsDataLoading: 0,
      detailsData: {},
      currentPage: 1,
      perPage: 15,
      reportsData: [],
      monthsReportsData: [],
      selectedYear: new Date().getFullYear(),
      yearsPull: [],
      employmentType: null,
      employmentSelect: [
        { value: 'all', label: 'All employment types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      defaultUserSlots: {
        index: {
          name: 'index'
        },
        name: {
          name: 'name'
        },
        avatar: {
          name: 'avatar'
        },
        action: {
          name: 'action',
          comment: false
        }
      },
      dynamicUserSlots: {},
      showModalOnInit: false,
      showingDetailsRows: [],
      isShowAdjustModal: false,
      isSubmittingAdjustment: false,
      currentAdjustUserId: null,
      adjustModalFields: {
        'time_offs_setting': {
          type: 'select',
          name: 'time_offs_settings_id',
          label: 'Time off type',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6 adjust-field-width'
        },
        'allowed': {
          type: 'slot',
          slotName: 'allowed',
          label: 'Allowed',
          value: null,
          disabled: true,
          class: 'col-12 col-md-6'
        },
        'adjustment_type': {
          type: 'select',
          name: 'adjustment_type',
          label: 'Adjustment type',
          selectLabel: 'label',
          valueField: 'sign',
          options: [{ sign: '+', label: 'Accrue (+)' }, { sign: '-', label: 'Subtract (-)' }],
          value: { sign: '+', label: 'Accrue (+)' },
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6 adjust-field-width'
        },
        'adjust': {
          type: 'input',
          name: 'adjust',
          label: 'Adjust',
          value: 1,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6'
        },
        'description': {
          type: 'slot',
          slotName: 'description',
          name: 'description',
          label: 'Description *',
          placeholder: 'Enter description ...',
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-12'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      timeOffsSettings: 'timeOffsSettings/getTimeOffsSettings'
    }),
    isPayable () {
      return this.adjustModalFields.time_offs_setting.value && this.adjustModalFields.time_offs_setting.value.is_payable
    },
    adjustAllowedValue () {
      if (!this.adjustModalFields?.time_offs_setting?.value || !this.currentAdjustUserId) {
        return null
      }
      const keyName = (this.adjustModalFields.time_offs_setting.value.name.toLowerCase() + 'timeoffsallowed').replaceAll(' ', '')
      const userData = this.tableData.find(item => item.user.id === this.currentAdjustUserId)
      return userData ? userData[keyName] : null
    },
    monthsSlots () {
      const defaultSlots = {
        month: {
          name: 'month'
        }
      }

      return {
        ...defaultSlots,
        ...this.monthsDynamicSlots,
        ...this.monthsDynamicHeadSlots
      }
    },
    monthsDynamicHeadSlots () {
      const result = {}

      this.monthsDynamicTableColumns.forEach((el) => {
        result[el.key + '.head'] = { name: el.key, type: 'head' }
      })
      return result
    },
    monthsDynamicSlots () {
      const result = {}

      this.monthsDynamicTableColumns.forEach((el) => {
        result[el.key] = { name: el.key }
      })
      return result
    },

    currentYearIndex () {
      if (this.yearsPull.length) {
        return this.yearsPull.indexOf(this.selectedYear)
      }
      return 0
    },
    isLastYearSelected () {
      if (this.currentYearIndex < this.yearsPull.length - 1) {
        return false
      }
      return true
    },
    isFirstYearSelected () {
      if (this.currentYearIndex > 0) {
        return false
      }
      return true
    },
    selectedYearDate () {
      return new Date(this.selectedYear, 0, 1)
    },
    selectedYearData () {
      return this.reportsData.find(
        (report) => report.year === this.selectedYear
      )
    },
    selectedYearMonthsData () {
      return this.monthsReportsData?.find(
        (report) => Number(report.year) === this.selectedYear
      )
    },
    reportGroupsSlots () {
      let groups = {}
      this.selectedYearData.fields.forEach((field) => {
        groups[field + 'head'] = { name: field, type: 'head' }
      })
      return groups
    },

    reportSlots () {
      return {
        ...this.defaultUserSlots,
        ...this.dynamicUserSlots,
        ...this.reportGroupsSlots,
        'worked_days.head': { name: 'worked_days', type: 'head' }
      }
    },
    tableColumns () {
      const defaultCols = [
        {
          key: 'index',
          label: '#',
          class: 'number-column'
        },
        {
          key: 'name',
          label: 'User'
        },
        {
          key: 'worked_days',
          label: 'Workdays passed',
          class: 'text-right'
        },
        {
          key: 'working_days_count',
          label: 'Working days in year',
          class: 'text-right pt-2'
        }
      ]

      const cols = Object.values(this.selectedYearData.year_items[0].user_items)
        .map((userItem) => {
          if (userItem.is_unlimited) {
            return [
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_used`
                ),
                label: 'Used',
                class: `text-center ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_used`
              }
            ]
          } else {
            return [
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_allowed`
                ),
                label: 'Allowed',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_allowed`
              },
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_used`
                ),
                label: 'Used',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_used`
              },

              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_left`
                ),
                label: 'Left',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_left`
              }
            ]
          }
        })
        .flat(Infinity)

      return [
        ...defaultCols,
        ...cols,
        {
          key: 'action',
          label: 'Actions',
          class: 'column-controls-md'
        }
      ]
    },
    tableData () {
      return this.getTableData()
    },
    colGroups () {
      const groups = this.selectedYearData?.fields.map((field) => {
        return {
          key: field.toLowerCase(),
          isHead: true,
          icon: this.getTimeOffIcon(field),
          label: field.replaceAll('_', ' '),
          colspan: Object.values(
            this.selectedYearData.year_items[0].user_items
          ).find((f) => f.time_offs_name === field).is_unlimited
            ? 1
            : 3,
          class:
            field.class ||
            'item-width text-right nested-table-left-border nested-table-right-border py-3'
        }
      })

      return [
        { key: 'default', label: '', class: 'width-30p', colspan: 4 },
        ...groups
      ]
    },
    monthsDynamicTableColumns () {
      const dynamicCols = []

      if (this.selectedYearMonthsData) {
        this.colGroups.forEach((item) => {
          if (item.isHead) {
            const findedItem = this.selectedYearMonthsData?.items.find(
              (el) => el?.type?.toLowerCase() === item?.label?.toLowerCase()
            )
            if (findedItem) {
              let summDays = this.monthsTableData.reduce((acc, it) => {
                if (it.items.length) {
                  it.items.forEach((e) => {
                    if (e.type?.toLowerCase() === item.key?.toLowerCase()) {
                      acc += e.days
                    }
                  })
                }
                return acc
              }, 0)

              dynamicCols.push({
                key: item.label,
                class:
                  'text-center item-width nested-table-left-border nested-table-right-border',
                label: {
                  text: item.label.toUpperCase(),
                  value: summDays + ' d',
                  icon: this.getTimeOffIcon(item.label)
                }
              })
            } else {
              dynamicCols.push({
                key: item.label,
                class:
                  'text-center item-width nested-table-left-border nested-table-right-border',
                label: {
                  text: item?.label?.toUpperCase(),
                  value: 0 + ' d',
                  icon: this.getTimeOffIcon(item.label)
                }
              })
            }
          }
        })
      }

      return dynamicCols
    },

    monthsTableColumns () {
      const columns = {
        key: 'month',
        label: 'Months',
        class: 'width-30p',
        style: 'background-color: white;'
      }
      return [
        columns,
        ...this.monthsDynamicTableColumns,
        { key: 'action', label: '', class: 'column-controls-md' }
      ]
    },

    shouldUseFullWidth () {
      // Use full width when there are many columns (more than a threshold)
      // Calculate estimated table width based on column count
      const fixedColumnsWidth = 42 + 188 + 67 + 67 // index, name, worked days, working days
      const dynamicColumnsCount = this.colGroups ? this.colGroups.filter(col => col.isHead).length : 0
      const dynamicColumnsWidth = dynamicColumnsCount * 170 // average column width
      const actionsColumnWidth = 60
      const estimatedTableWidth = fixedColumnsWidth + dynamicColumnsWidth + actionsColumnWidth

      // Use full width if estimated table width exceeds viewport or if many columns
      return estimatedTableWidth > window.innerWidth
    },

    shouldUseFullWidthForMonths () {
      // Use full width for months table when there are many columns
      // Calculate estimated table width based on month table column count
      const monthsFixedColumnWidth = 353 // months column
      const monthsDynamicColumnsCount = this.monthsDynamicTableColumns ? this.monthsDynamicTableColumns.length : 0
      const monthsDynamicColumnsWidth = monthsDynamicColumnsCount * 170 // average column width
      const monthsActionsColumnWidth = 45
      const estimatedMonthsTableWidth = monthsFixedColumnWidth + monthsDynamicColumnsWidth + monthsActionsColumnWidth
      // Use full width if estimated table width exceeds viewport or if many columns
      return estimatedMonthsTableWidth > window.innerWidth
    },

    monthsTableData () {
      let result = [
        { month: 'January', items: [] },
        { month: 'February', items: [] },
        { month: 'March', items: [] },
        { month: 'April', items: [] },
        { month: 'May', items: [] },
        { month: 'June', items: [] },
        { month: 'July', items: [] },
        { month: 'August', items: [] },
        { month: 'September', items: [] },
        { month: 'October', items: [] },
        { month: 'November', items: [] },
        { month: 'December', items: [] }
      ]
      // eslint-disable-next-line
      this.selectedYearMonthsData?.items.forEach((entry) => {
        if (!entry.items || !Array.isArray(entry.items)) return
        entry.items.forEach((monthItem) => {
          if (!monthItem.month || typeof monthItem.days !== 'number') return

          result.forEach((el) => {
            if (el.month === monthItem.month) {
              const summ = monthItem.items.reduce(
                (acc, el) => acc + el.days,
                0
              )
              el.type = entry.type
              el.items.push(
                ...monthItem.items.map((el) => ({
                  date:
                    el.start === el.end
                      ? this.formatDate(el.start)
                      : this.formatDate(el.start) + ' - ' + this.formatDate(el.end),
                  days: el.days,
                  type: entry.type
                }))
              )
              el.summ = summ
            }
          })
        })
      })
      return result
    }
  },
  async mounted () {
    await this.fetchTimeOffsSettings()

    const params = this.timeOffReportUserId
      ? { user_ids: [this.timeOffReportUserId] }
      : {}

    await this.getTimeOffsData(params)
  },
  watch: {
    yearsPull (newValue) {
      if (newValue && newValue.length) {
        if (!newValue.includes(this.selectedYear)) {
          this.selectedYear = Math.max(...newValue)
        }
      }
    },
    selectedYear () {
      this.detailsData = {}
    },
    adjustAllowedValue (newValue) {
      this.adjustModalFields.allowed.value = newValue
    }
  },
  methods: {
    showDetails (row) {
      if (this.showingDetailsRows.includes(row.month)) {
        this.showingDetailsRows = this.showingDetailsRows.filter(
          (item) => item !== row.month
        )
      } else {
        this.showingDetailsRows.push(row.month)
      }
    },
    async fetchTimeOffsSettings () {
      return this._toggleDataPageLoading(() =>
        this.$api.timeOffsSettings.getTimeOffsSettings()
      )
    },
    async getTimeOffsData (params) {
      this.isLoading = true
      await this.axios
        .post('/api/report/timeOffs', params, {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        })
        .then((response) => {
          if (response.status === 200) {
            let reportsData = response.data?.user_worked_days_report || response.data

            // Ensure all users have all fields from fields array
            reportsData = reportsData.map(yearData => {
              const updatedYearItems = yearData.year_items.map(userItem => {
                const updatedUserItems = [...userItem.user_items]

                // Check each field in the fields array
                yearData.fields.forEach(fieldName => {
                  const existingItem = updatedUserItems.find(item => item.time_offs_name === fieldName)

                  // If user doesn't have this field, add default values
                  if (!existingItem) {
                    const defaultItem = this.createDefaultUserItem(fieldName, userItem.worked_days)
                    updatedUserItems.push(defaultItem)
                  }
                })

                return {
                  ...userItem,
                  user_items: updatedUserItems
                }
              })

              return {
                ...yearData,
                year_items: updatedYearItems
              }
            })

            this.reportsData = reportsData
            this.monthsReportsData = response.data?.time_offs_report?.[0]
            this.yearsPull = this.reportsData
              .map((el) => el.year)
              .sort((a, b) => a - b)
          }
        })
        .catch(console.error)
        .finally(() => {
          this.isLoading = false
        })
    },
    async getTimeOffsUserData (userId) {
      await this.axios
        .post(
          '/api/report/timeOffs',
          { user_ids: [userId] },
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then((response) => {
          if (response.status === 200) {
            const yearData = response.data.user_worked_days_report.find(
              (el) => el.year === this.selectedYear
            )
            let updatedUserItems = yearData.year_items.find(
              (el) => el.user.id === userId
            ).user_items

            // Ensure this user has all fields from local state fields array
            const userItem = yearData.year_items.find(el => el.user.id === userId)
            const localYearData = this.reportsData.find(el => el.year === this.selectedYear)

            if (localYearData && localYearData.fields) {
              // Rebuild user_items in the same order as fields array
              const orderedUserItems = []

              localYearData.fields.forEach(fieldName => {
                const existingItem = updatedUserItems.find(item => item.time_offs_name === fieldName)

                if (existingItem) {
                  orderedUserItems.push(existingItem)
                } else {
                  const defaultItem = this.createDefaultUserItem(fieldName, userItem.worked_days)
                  orderedUserItems.push(defaultItem)
                }
              })

              updatedUserItems = orderedUserItems
            }

            let res = null

            if (this.timeOffReportUserId) {
              res = response.data.user_worked_days_report
            } else {
              res = this.reportsData.map((el) => {
                if (el.year === this.selectedYear) {
                  const updatedYearItems = el.year_items.map((item) => {
                    if (item.user.id === userId) {
                      return {
                        ...item,
                        user_items: updatedUserItems
                      }
                    } else {
                      return item
                    }
                  })

                  return { ...el, year_items: updatedYearItems }
                } else {
                  return el
                }
              })
            }

            this.reportsData = [...res]
          }
        })
        .catch(console.error)
    },

    async fetchAdustments (userId, year) {
      const response =
        await this.$api.timeOffsAdjustments.fetchTimeOffsAdjustments(
          userId,
          year
        )
      return response.data
    },

    previousYearClick () {
      if (this.currentYearIndex > 0) {
        this.selectedYear = this.yearsPull[this.currentYearIndex - 1]
      }
    },
    nextYearClick () {
      if (this.currentYearIndex < this.yearsPull.length - 1) {
        this.selectedYear = this.yearsPull[this.currentYearIndex + 1]
      }
    },
    handleYearChange (direction) {
      if (direction === 'prev') {
        this.previousYearClick()
      } else if (direction === 'next') {
        this.nextYearClick()
      }
    },
    handleYearSelect (date, type) {
      this.selectedYear = date.getFullYear()
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return this.perPage * curPage + index
      } else {
        return index
      }
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    async fetchAdustmentsHandler (userId) {
      try {
        this.userDetailsDataLoading = userId
        const data = await this.fetchAdustments(userId, this.selectedYear)
        this.detailsData = {
          ...this.detailsData,
          [userId]: data
        }

        // Scroll to the left after data is loaded
        this.$nextTick(() => {
          const tableWrapper = document.querySelector('.table-responsive-wrapper')
          if (tableWrapper) {
            tableWrapper.scrollLeft = 0
          }
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.userDetailsDataLoading = 0
      }
    },
    async visibilityActionClick (slotProps) {
      this.showModalOnInit = false
      const userId = slotProps.item.user.id

      slotProps.toggleDetails()
      if (slotProps.detailsShowing === false) {
        // load data if we are opening details. detailsShowing === false means that details are closed at the moment
        await this.fetchAdustmentsHandler(userId)
      }
    },
    resetAdjustModalFields () {
      this.adjustModalFields.time_offs_setting.value = null
      this.adjustModalFields.allowed.value = null
      this.adjustModalFields.adjustment_type.value = { sign: '+', label: 'Accrue (+)' }
      this.adjustModalFields.adjust.value = 1
      this.adjustModalFields.description.value = null
    },
    handleEditClick (userId) {
      this.resetAdjustModalFields()

      this.currentAdjustUserId = userId
      this.initAdjustModal()
      this.isShowAdjustModal = true
    },
    initAdjustModal () {
      this.adjustModalFields.time_offs_setting.options = this.timeOffsSettings
      this.adjustModalFields.time_offs_setting.value = this.timeOffsSettings[0]
    },
    closeAdjustModal () {
      this.isShowAdjustModal = false
      this.isSubmittingAdjustment = false
      this.currentAdjustUserId = null

      // Clear FormGenerator validation before resetting values
      if (this.$refs.form && this.$refs.form.clearValidation) {
        this.$refs.form.clearValidation()
      }
    },
    updateAdjustModalItem (key, itemData) {
      this.adjustModalFields[key] = itemData
    },
    updateDescriptionValue (value) {
      this.adjustModalFields.description.value = value
    },
    submitAdjustment (fields) {
      const data = this.prepareFormFieldsForRequest(fields)
      data['user_id'] = this.currentAdjustUserId
      data['year'] = this.selectedYear
      this.isSubmittingAdjustment = true
      this.$api.timeOffsAdjustments.addTimeOffsAdjustment(data)
        .then(async () => {
          this.$snotify.success(
            'Time off successfully adjusted',
            'Success',
            this.$store.state.snotify
          )
          this.isShowAdjustModal = false
          this.dataUpdated(this.currentAdjustUserId)
          this.closeAdjustModal()
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.isSubmittingAdjustment = false
        })
    },
    prepareFormFieldsForRequest (fields) {
      let data = {}
      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        data[name] = typeof value === 'object' && !(value instanceof Array) ? value[field['valueField']] : value
      }
      return data
    },
    formatDate (dateString) {
      // Parse the date and set it to the selected year
      const date = moment(dateString).year(this.selectedYear)
      return date.format('DD.MM.YYYY')
    },
    getTableData () {
      if (!this.selectedYearData) return []

      const arr =
        this.employmentType && this.employmentType?.value !== 'all'
          ? this.selectedYearData.year_items.filter(
            (el) => el.user.employment_type.id === this.employmentType.value
          )
          : this.selectedYearData.year_items
      const result = arr.map((el) => {
        let item = {
          user: el.user,
          worked_days: el.worked_days,
          working_days_count: this.selectedYearData.working_days_count
        }

        Object.values(el.user_items).forEach((x) => {
          if (x.is_unlimited) {
            item = {
              ...item,
              [this.formatKey(`${x.time_offs_name}_time_offs_used`)]:
                x.time_offs_used
            }
          } else {
            let key = this.formatKey(`${x.time_offs_name}_time_offs_allowed`)

            item = {
              ...item,
              [this.formatKey(`${x.time_offs_name}_time_offs_allowed`)]:
                x.time_offs_allowed,
              [this.formatKey(`${x.time_offs_name}_time_offs_used`)]:
                x.time_offs_used,
              [this.formatKey(`${x.time_offs_name}_time_offs_left`)]:
                x.time_offs_allowed + x.time_offs_adjust - x.time_offs_used,
              [this.formatKey(`${x.time_offs_name}_time_offs_allowed_adjust`)]:
                x.time_offs_adjust
            }

            this.dynamicUserSlots[key] = { name: key }
          }
        })
        return item
      })

      return result
    },
    formatKey (str) {
      return str.replace(/[_\s]/g, '').toLowerCase()
    },
    createDefaultUserItem (fieldName, workedDays) {
      const timeOffSetting = this.timeOffsSettings?.find(
        setting => setting.name === fieldName
      )
      const isUnlimited = timeOffSetting?.is_unlimited || false

      const defaultItem = {
        time_offs_name: fieldName,
        is_unlimited: isUnlimited,
        worked_days: workedDays,
        time_offs_allowed: 0,
        time_offs_used: 0,
        time_offs_left: 0,
        time_offs_adjust: 0
      }

      if (timeOffSetting) {
        defaultItem.time_offs_settings = timeOffSetting
      }

      return defaultItem
    },
    async dataUpdated (userId) {
      try {
        this.userDetailsDataLoading = userId
        await this.getTimeOffsUserData(userId)
        const data = await this.fetchAdustments(userId, this.selectedYear)
        this.detailsData = {
          ...this.detailsData,
          [userId]: data
        }

        const el = document.getElementById(`${userId}-action`)

        el.dispatchEvent(
          new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          })
        )

        this.userDetailsDataLoading = 0
      } catch (error) {
        console.error(error)
      }
    },
    onClose () {
      this.$emit('close')
    },
    getTimeOffIcon (settingName) {
      if (!this.timeOffsSettings.length) {
        return null
      }
      return this.timeOffsSettings.find(
        (setting) => setting.name === settingName
      )
    },
    handleResetFilters () {
      // Reset employment type filter to default
      this.employmentType = this.employmentSelect[0]
    },
    getColumnMinWidth (columnText, offsetPx = 0) {
      // Find the corresponding column in colGroups by matching the label text
      const matchingColumn = this.colGroups.find(col =>
        col.label && col.label.toLowerCase() === columnText.toLowerCase()
      )

      let baseWidth
      if (matchingColumn) {
        baseWidth = matchingColumn.colspan === 1 ? 121 : 170
      } else {
        baseWidth = 170 // default fallback
      }

      return (baseWidth + offsetPx) + 'px'
    }
  }
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
// Global styles to override validation green borders in modal
.modal .form-control.is-valid,
.b-modal .form-control.is-valid,
.modal .multiselect.is-valid,
.b-modal .multiselect.is-valid,
.modal .multiselect__input.is-valid,
.b-modal .multiselect__input.is-valid,
.modal .vue-multiselect.is-valid,
.b-modal .vue-multiselect.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

.modal .form-control.is-valid:focus,
.b-modal .form-control.is-valid:focus,
.modal .multiselect.is-valid:focus,
.b-modal .multiselect.is-valid:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.modal textarea.is-valid,
.b-modal textarea.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

// Override multiselect validation borders
.modal .multiselect.is-valid .multiselect__tags,
.b-modal .multiselect.is-valid .multiselect__tags {
  border-color: #ced4da !important;
}

.modal .vue-multiselect.is-valid .multiselect__tags,
.b-modal .vue-multiselect.is-valid .multiselect__tags {
  border-color: #ced4da !important;
}
</style>

<style lang="scss" scoped>
// Remove green validation borders for successful validation
::v-deep .modal .form-control.is-valid,
::v-deep .b-modal .form-control.is-valid,
::v-deep .form-control.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

::v-deep .modal .form-control.is-valid:focus,
::v-deep .b-modal .form-control.is-valid:focus,
::v-deep .form-control.is-valid:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

// Also handle textarea specifically
::v-deep .modal textarea.is-valid,
::v-deep .b-modal textarea.is-valid,
::v-deep textarea.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

.remove-hover {
  pointer-events: none !important;
}

.add-hover {
  pointer-events: all !important;
}

.time-off-report-page {
  .header-gap {
    gap: 15px;
  }

  .actions-wrap {
    color: $iconColorAccent;
    display: flex;
    align-items: center;
    justify-content: right;
    gap: 4px;

    & .material-symbols-outlined {
      font-size: 20px;
    }

    & span {
      cursor: pointer;
    }
  }

  ::v-deep th.nested-table-left-border {
    border-left: 1px solid #e3e7ee !important;
  }

  ::v-deep th.nested-table-right-border {
    border-right: 1px solid #e3e7ee !important;
  }

  ::v-deep.item-width {
    width: 240px !important;
  }
}

::v-deep.b-table-details>td {
  padding: 0 !important;
}

::v-deep.table__theme-default>.table-container {
  padding-top: 0;
}

::v-deep.table-responsive-wrapper>.table-fullscreen>.table-container {
  padding-left: 0;
  border-radius: 0;
}

::v-deep .table-title {
  padding-top: 20px;
}

.detailed-dates-row {
  padding-top: unset;
  border: none;

  td {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

::v-deep .py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

/* Completely hide nested table thead content */
::v-deep thead[style*="visibility: hidden"] {
  height: 0 !important;
  visibility: hidden;
}

::v-deep thead[style*="visibility: hidden"] * {
  height: 0 !important;
  visibility: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

::v-deep .main-head {
  margin-top: 4px;
}

::v-deep .nested-table>table>thead,
::v-deep .nested-table>table tbody tr:nth-child(even) {
  background-color: rgba(228, 231, 238, 0.5) !important;
}

::v-deep .nested-table>table>thead tr:hover {
  background-color: unset;
}

::v-deep .nested-table>table tbody tr:nth-child(odd) {
  background-color: rgba(243, 245, 247, 0.5) !important;
}

.table-responsive-outter-wrapper {
  padding: 0 16px;
  border-radius: 10px;
  background-color: white;
}

// Horizontal scroll wrapper
.table-responsive-wrapper {
  overflow-x: auto;
  overflow-y: visible;

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    height: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: #E3E7EE;
    border-radius: 25px;
    margin: 0 18px;
  }

  &::-webkit-scrollbar-thumb {
    background: #C5CBDA;
    border-radius: 25px;

    &:hover {
      background: #B0B0C8;
    }
  }

  // Firefox scrollbar
  scrollbar-width: thin;
  scrollbar-color: #C5CBDA #E3E7EE;

  .time-off-user-table {

    ::v-deep .table-hover tbody tr,
    ::v-deep .main-head {
      background-color: white;
    }

    // Sticky columns for first 4 columns
    ::v-deep .table .main-head th:nth-child(1),
    ::v-deep .table td:nth-child(1) {
      position: sticky;
      padding-left: 25px;
      left: 0px;
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(2),
    ::v-deep .table td:nth-child(2) {
      position: sticky;
      min-width: 188px;
      max-width: 188px;
      left: 18px; // width of first column
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(3),
    ::v-deep .table td:nth-child(3) {
      position: sticky;
      left: 206px; // width of first two columns
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(4),
    ::v-deep .table td:nth-child(4) {
      position: sticky;
      left: 301px; // width of first three columns
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table:not(.main-head) th:nth-child(1) {
      position: sticky;
      left: 0;
      z-index: 2;
      background-color: white;
    }
  }
}

.used-by-months-table-wrapper {
  padding: 0 25px;
  background-color: white;
  border-radius: 10px;
}

::v-deep .used-by-months-table-wrapper .table-title {
  left: 0;
  z-index: 2;
  position: sticky;
  width: 200px;
}

::v-deep .used-by-months-table tr th:first-child,
::v-deep .used-by-months-table tr td:first-child {
  min-width: 365px;
  max-width: 365px;
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: inherit;
}

::v-deep .used-by-months-table tr {
  background-color: white;
}

::v-deep .used-by-months-table .column-controls-md {
  min-width: 45px;
}

::v-deep .months-subtable tr {
  background-color: #F3F5F7;
}

::v-deep.table-responsive-wrapper>.table-fullscreen {
  min-width: fit-content;
}

::v-deep .pagination{
  width: fit-content;
  left: 0;
  position: sticky;
}
</style>
